import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { FechamentoCartaConsorcioModel } from "../models/fechamento-carta-consorcio.model";

@Injectable()
export class FechamentoCartaConsorcioService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Status de Carta Consorcio por id
     * @param id ID da Status de Carta Consorcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/fechamento-carta-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Status de Carta Consorcio
     * @param id ID da Status de Carta Consorcio
     */
    getAll(
        params: Record<string, unknown>
    ): Observable<ApiPaginationResponseDataNonNullable<FechamentoCartaConsorcioModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<FechamentoCartaConsorcioModel>>(
            this.utilitesService.urlPrefix + "consorcio/fechamento-carta-consorcio" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Delete de Status de Carta Consorcio
     * @param id ID da Status de Carta Consorcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/fechamento-carta-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Status de Carta Consorcio
     * @param params Json Status de Carta Consorcio
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "consorcio/fechamento-carta-consorcio",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Status de Carta Consorcio
     * @param params Json Status de Carta Consorcio
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "consorcio/fechamento-carta-consorcio/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
